import { render, staticRenderFns } from "./buy-join.vue?vue&type=template&id=60dc71ae&scoped=true"
import script from "./buy-join.vue?vue&type=script&lang=js"
export * from "./buy-join.vue?vue&type=script&lang=js"
import style0 from "./buy-join.vue?vue&type=style&index=0&id=60dc71ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc71ae",
  null
  
)

export default component.exports